import React from 'react';

const HomeIcon = () => (
  <svg width="48" height="40" viewBox="196 0 48 40" xmlns="http://www.w3.org/2000/svg">
    <polygon
      id="Home-Icon"
      fill="#F96302"
      fillRule="evenodd"
      points="215.2 40 215.2 25.8823529 224.8 25.8823529 224.8 40 236.8 40 236.8 21.1764706 244 21.1764706 231.584405 10.221534 220 0 196 21.1764706 203.2 21.1764706 203.2 40"
    />
  </svg>
);

export default HomeIcon;
